<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <div>
      <h6
        class="
          tx-uppercase tx-10 tx-mont tx-spacing-1
          mg-t-10
          pd-x-10
          tx-white-7
        "
      >
        {{ $t("warehouse.条件筛选") }}
      </h6>
      <div class="mg-t-10 pd-x-10 mg-b-40">
        <div class="mg-b-15 form-group">
          <input
            type="text"
            :placeholder="$t('warehouse.仓库名称')"
            class="form-control form-control-dark tx-14"
            @keyup.enter="filtrate()"
            v-model.trim="keyName"
          />
        </div>
        <div class="mg-b-10 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            v-model="keyStatus"
            @change="filtrate"
          >
            <option value="">{{ $t("warehouse.全部状态") }}</option>
            <option v-for="(s, k) in $dict.storeStatus" :key="k" :value="k">
              {{ $t(s) }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <button
      class="
        btn btn-primary btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
      @click="filtrate()"
    >
      {{ $t("dashboard.筛 选") }}
    </button>
  </div>
</template>

<script>
export default {
  props: ["status", "key_name", "key_status"],
  data() {
    return {
      keyName: "",
      keyStatus: "",
    };
  },
  watch: {
    key_name() {
      this.keyName = this.key_name;
    },
    key_status() {
      this.keyStatus = this.key_status;
    },
  },
  methods: {
    filtrate() {
      this.$emit("filtrate", this.keyName, this.keyStatus);
    },
  },
  updated() {
    if (this.status) {
      $(".overflow-y-auto").perfectScrollbar("destroy");
    } else {
      $(".overflow-y-auto").perfectScrollbar();
    }
  },
};
</script>
